import axios from '../util/axiosUtil.js'

// 记录网站访问量
export function recordVisitCount() {
    return axios({
        url: '/api/dataCenter/visitCount',
        method: 'post'
    })
} 